"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dompurify_1 = __importDefault(require("dompurify"));
var DangerSet = function (props) {
    // To Solve the error: Argument of type 'ReactNode' is not assignable to parameter of type 'string | Node'.
    var preSanitizedHTML = typeof props.children === 'string' ? props.children : '';
    var config = { ADD_TAGS: ['iframe'], KEEP_CONTENT: false };
    var sanitizedHTML = dompurify_1.default.sanitize(preSanitizedHTML, config);
    return (
    // eslint-disable-next-line react/no-danger
    (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: sanitizedHTML } }));
};
exports.default = DangerSet;
//# sourceMappingURL=danger-set.component.js.map